import { getValueReduxUtil } from '../../modules/redux/utils/get-value'

export function getOrderInstanceUtil (instance) {
  return getValueReduxUtil(instance, 'order')
}

export function getTypeInstanceUtil (instance) {
  return getValueReduxUtil(instance, 'type')
}

export function getTitleInstanceUtil (instance) {
  return getValueReduxUtil(instance, 'title')
}

export function getDescriptionInstanceUtil (instance) {
  return getValueReduxUtil(instance, 'description')
}

export {
  default as isOwnerModelUtil
} from './is-owner'

export * from './get-profile-id'
